/**
 * AutomatedStatsOverview - Stats cards for automated campaigns
 */
import { Cake, Gift, UserMinus, FlaskConical } from 'lucide-react';

function StatCard({ label, value, subtext, icon: Icon, color }) {
  return (
    <div className="bg-card rounded-xl border border-border p-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-muted flex items-center justify-center">
          <Icon className={`w-5 h-5 ${color}`} />
        </div>
        <div>
          <p className="text-xl font-bold text-foreground">{value}</p>
          <p className="text-xs text-muted-foreground">{label}</p>
          {subtext && <p className="text-xs text-muted-foreground/70">{subtext}</p>}
        </div>
      </div>
    </div>
  );
}

export default function AutomatedStatsOverview({ stats }) {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <StatCard 
        label="Upcoming Birthdays" 
        value={stats.birthday?.upcoming_7_days || 0}
        subtext="Next 7 days"
        icon={Cake}
        color="text-pink-500"
      />
      <StatCard 
        label="Birthday Sent" 
        value={stats.birthday?.sent_last_30_days || 0}
        subtext="Last 30 days"
        icon={Gift}
        color="text-purple-500"
      />
      <StatCard 
        label="Eligible for Win-Back" 
        value={stats.reengagement?.eligible_now || 0}
        subtext="Inactive customers"
        icon={UserMinus}
        color="text-orange-500"
      />
      <StatCard 
        label="Active A/B Tests" 
        value={stats.ab_testing?.active_tests || 0}
        subtext="Running experiments"
        icon={FlaskConical}
        color="text-blue-500"
      />
    </div>
  );
}
